export interface ResolveEffectiveRegionInput {
  urlLocale: string | undefined;
  catalogDefaultRegion: string;
}

const FULL_LOCALE_HINT =
  'Pass a full BCP-47 locale with both language and region, such as "en-US" (English, United States) ' +
  'or "de-DE" (German, Germany). A language alone ("en") or a region alone ("US") is not enough — ' +
  'the configurator needs both subtags to format numbers, prices, and dimensions deterministically.';

function parseHostLocale(urlLocale: string): Intl.Locale {
  const trimmedLocale = urlLocale.trim();
  if (!trimmedLocale) {
    throw new Error('Locale query param must not be empty');
  }

  let locale: Intl.Locale;
  try {
    locale = new Intl.Locale(trimmedLocale);
  } catch {
    throw new Error(`Invalid ?locale value ${JSON.stringify(urlLocale)}. ${FULL_LOCALE_HINT}`);
  }

  if (!trimmedLocale.includes('-') || !locale.region) {
    throw new Error(`Invalid ?locale value ${JSON.stringify(urlLocale)}: missing region subtag. ${FULL_LOCALE_HINT}`);
  }

  return locale;
}

export function resolveEffectiveLocale({ urlLocale, catalogDefaultRegion }: ResolveEffectiveRegionInput): string {
  if (!urlLocale) return catalogDefaultRegion;
  return parseHostLocale(urlLocale).toString();
}

export function resolveEffectiveRegion({ urlLocale, catalogDefaultRegion }: ResolveEffectiveRegionInput): string {
  if (!urlLocale) return catalogDefaultRegion;
  return parseHostLocale(urlLocale).region ?? catalogDefaultRegion;
}
